const NAMESPACE = "pcComponentDefaults";

const KEYS = {
    pcCapsuleDefaultHeader: "pcCapsuleDefaultHeader",
    pcExpandListEmptyMessage: "pcExpandListEmptyMessage",
    pcExpandListShowLess: "pcExpandListShowLess",
    pcExpandListShowMore: "pcExpandListShowMore",
    pcLoaderLoadingMessage: "pcLoaderLoadingMessage",
    pcSectionDefaultTitle: "pcSectionDefaultTitle",
    pcSensitiveIconTitleIsAttachment: "pcSensitiveIconTitleIsAttachment",
    pcSensitiveIconTitleIsField: "pcSensitiveIconTitleIsField",
    pcCopyableFeedbackPopper: "pcCopyableFeedbackPopper"
};

const MESSAGES = {
    [KEYS.pcCapsuleDefaultHeader]: {
        value: "Default Header",
        comment: "Header text for the capsule component if no header is specified."
    },
    [KEYS.pcExpandListEmptyMessage]: {
        value: "Nothing to show",
        comment: "Message that appears in the expand list component if there aren't any items to show."
    },
    [KEYS.pcExpandListShowLess]: {
        value: "Show less",
        comment:
            "Message that appears in the expand list component when the user has an opportunity " +
            "to show fewer items."
    },
    [KEYS.pcExpandListShowMore]: {
        value: "Show {moreItems} more",
        comment:
            "Message that appears in the expand list component when the user has an opportunity " +
            "to show fewer items. The text in the brackets is replaced by the number of hidden items."
    },
    [KEYS.pcLoaderLoadingMessage]: {
        value: "Loading...",
        comment: "Default message that appears while interaction is blocked by the loader component."
    },
    [KEYS.pcSectionDefaultTitle]: {
        value: "Default Section",
        comment: "Title text for the section component if no title is specified."
    },
    [KEYS.pcSensitiveIconTitleIsAttachment]: {
        value: "This attachment contains sensitive data.",
        comment: "Title text for a Sensitive Icon that has an attachment."
    },
    [KEYS.pcSensitiveIconTitleIsField]: {
        value: "This field contains sensitive data.",
        comment: "Title text for a Sensitive Icon that has a field."
    },
    [KEYS.pcCopyableFeedbackPopper]: {
        value: "Copied",
        comment: "Text for the popper that appears after someone clicks the copy button"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
